var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationPinFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 18",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00005 17.0359C7.00005 17.0359 0.75 11.9019 0.75 7.21441C0.75 3.76259 3.54824 0.964355 7.00005 0.964355C10.4519 0.964355 13.2501 3.76259 13.2501 7.21441C13.2501 11.9019 7.00005 17.0359 7.00005 17.0359ZM7.00037 9.89283C5.52089 9.89283 4.32178 8.69371 4.32178 7.21424C4.32178 5.73476 5.52089 4.53564 7.00037 4.53564C8.47985 4.53564 9.67896 5.73476 9.67896 7.21424C9.67896 8.69371 8.47985 9.89283 7.00037 9.89283Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinFilled);
export default __webpack_public_path__ + "static/media/location-pin-filled.1cd6f9c9265fc78699c7366dba2c1116.svg";
export { ForwardRef as ReactComponent };